import Vue from 'vue';

import axios from '@/services/axios'
import api from '@/services/api'

Vue.prototype.$axios = axios
Vue.prototype.$api = api
